import TickerItems from "../TickerItems";
import TickerLeagueContent from "../league/TickerLeagueContent";
import TickerStandingContent from "../standing/TickerStandingContent";
import TickerResultsContent from "../results/TickerResultsContent";
import TickerUpcomingContent from "../upcoming/TickerUpcomingContent";
import TickerNewsContent from "../news/TickerNewsContent";
import { SHOW_STANDINGS, SHOW_NEWS, SHOW_UPCOMING, SHOW_RESULTS, SHOW_BOTH_BLOCKS } from "../../constants-ticker";
import { shouldShowUpcoming } from "./tickerSportUtils";

/** Ensambla las secciones de un objeto de liga, sin mezclar sus contenidos. */
export default function TickerSportContent({
  leagueData,
  showLeague = true,
  resultsRef,
  newsRef,
  footResultsActive = false,
  newsActive = false,
}) {
  const league = leagueData?.league;
  const sportCode = league?.sport_code?.toUpperCase();
  const isBase = sportCode === "BASE";
  // BASE (MLB) y AMFO (NFL) muestran ambos bloques (results + upcoming) solo si
  // `SHOW_BOTH_BLOCKS` está activo; si no, aplican la validación de FOOT.
  const showsBothBlocks = (isBase || sportCode === "AMFO") && SHOW_BOTH_BLOCKS;

  // Validación de FOOT: a 24h o menos del primer partido de upcoming se muestran
  // los próximos y se ocultan los resultados (mutuamente excluyentes).
  // Cuando `showsBothBlocks` es true (BASE/AMFO con la bandera activa): muestran
  // SIEMPRE ambos bloques. Los results usan carrusel vertical con parada; el
  // upcoming se desplaza de forma horizontal (listado), sin parada.
  const showFootUpcoming = !showsBothBlocks && SHOW_UPCOMING && shouldShowUpcoming(leagueData?.upcoming);
  const showUpcoming = showsBothBlocks ? SHOW_UPCOMING : showFootUpcoming;

  return <TickerItems
    leagueContent={showLeague ? <TickerLeagueContent league={league} /> : null}
    standingContent={SHOW_STANDINGS ? <TickerStandingContent standing={leagueData?.standing} sportCode={sportCode} /> : null}
    resultsContent={(!SHOW_RESULTS || showFootUpcoming) ? null : (
      <div ref={resultsRef} className="ticker-content-results-block">
        <TickerResultsContent
          results={leagueData?.results}
          league={league}
          sportCode={sportCode}
          isActive={footResultsActive}
        />
      </div>
    )}
    upcomingContent={showUpcoming ? (
      <TickerUpcomingContent upcoming={leagueData?.upcoming} league={league} sportCode={sportCode} />
    ) : null}
    newsContent={SHOW_NEWS ? (
      <div ref={newsRef} className="ticker-content-news-block">
        <TickerNewsContent news={leagueData?.news} isActive={newsActive} />
      </div>
    ) : null}
  />;
}